import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Collapse } from 'reactstrap';
import { checkUrlIsExternal } from '../Shared/CheckUrl';
import MobileNavBarItems from './mobileNavBarItems';
export default function NavFlyover(props) {
    var closeMobileNav = props.closeMobileNav, setCloseMobileNav = props.setCloseMobileNav, menuData = props.menuData, rootUrl = props.rootUrl, generalSettings = props.generalSettings, closeAlert = props.closeAlert, hideBookNow = props.hideBookNow;
    var TitleTag = (menuData.fields.titleTag || 'h1');
    var SubtitleTag = (menuData.fields.subtitleTag || 'h2');
    var prevScrollY = useRef(0);
    var defaultNavHeight = useRef(0);
    var wasScrolledUp = useRef(false);
    var isNavHovered = useRef(false);
    var hideNavTimeout = useRef(null);
    var navElement = useRef(null);
    var navPlaceholderElement = useRef(null);
    //const [goingUp, setGoingUp] = useState(false);
    //const [navTop, setNavTop] = useState(false);
    //const [initialNav, setInitialNav] = useState(false);
    //const [scrollUpVisible, setScrollUpVisible] = useState(false);
    //const [closeMobileNav, setCloseMobileNav] = useState(false);
    var _a = useState(null), hoverNavIndex = _a[0], setHoverNavIndex = _a[1];
    var _b = useState(null), clickNavIndex = _b[0], setClickNavIndex = _b[1];
    var _c = useState(null), mobileNavIndex = _c[0], setMobileNavIndex = _c[1];
    var _d = useState(0), navMobileHeight = _d[0], setNavMobileHeight = _d[1];
    function getVisibleHeight(element) {
        var rect = element.getBoundingClientRect();
        var windowHeight = window.innerHeight || document.documentElement.clientHeight;
        var top = Math.max(rect.top, 0);
        var bottom = Math.min(rect.bottom, windowHeight);
        return Math.max(0, bottom - top);
    }
    useEffect(function () {
        if (closeMobileNav) {
            var alerts = document.getElementById('all-alerts');
            var logo = document.getElementById('logo-mobile');
            var tickets = document.getElementById('buy-tickets-mobile');
            var phone = document.getElementById('phone-hours');
            var navHeight = window.innerHeight
                - (alerts ? getVisibleHeight(alerts) : 0)
                - (logo ? getVisibleHeight(logo) : 0)
                - (tickets ? getVisibleHeight(tickets) : 0)
                - (phone ? getVisibleHeight(phone) : 0);
            setNavMobileHeight(navHeight);
        }
    }, [closeMobileNav, closeAlert]);
    function areNumbersEqualWithMargin(number1, number2, margin) {
        return Math.abs(number1 - number2) <= margin;
    }
    function tryHideNav(callback) {
        console.log("Timeout hide the nav now: ", isNavHovered.current);
        if (isNavHovered.current) {
            hideNavTimeout.current = setTimeout(function () { return tryHideNav(callback); }, 1000);
        }
        else {
            callback && callback();
        }
    }
    useEffect(function () {
        var hideNav = function () {
        };
        var handleResize = function () {
            if (navElement.current && navElement.current.classList.contains("nav-fixed")) {
                defaultNavHeight.current = (navElement.current && navElement.current.getBoundingClientRect().height || 0);
            }
            if (navPlaceholderElement.current && navElement.current) {
                navPlaceholderElement.current.style.height = defaultNavHeight.current + "px";
            }
        };
        handleResize();
        var handleNavVisibility = function (forceHide) {
            if (forceHide === void 0) { forceHide = false; }
            var navHeight = defaultNavHeight.current || (navElement.current && navElement.current.getBoundingClientRect().height || 0); //document.getElementById("navbar").offsetHeight;
            var initialNav = true;
            var goingUp = false;
            var navTop = true;
            var scrollUpVisible = false;
            var currentScrollY = window.scrollY;
            if (currentScrollY > navHeight) {
                //setInitialNav(true);
                initialNav = true;
                wasScrolledUp.current = wasScrolledUp.current || prevScrollY.current > currentScrollY;
            }
            else {
                wasScrolledUp.current = false;
                if (currentScrollY == 0) {
                    //setInitialNav(false);
                    initialNav = false;
                }
            }
            if ((prevScrollY.current) < currentScrollY && goingUp) {
                //setGoingUp(false);
                goingUp = false;
            }
            if ((prevScrollY.current) > currentScrollY && !goingUp) {
                //setGoingUp(true);
                goingUp = true;
            }
            //setNavTop(window.pageYOffset === 0 ? true : false);
            navTop = window.pageYOffset === 0 ? true : false;
            //setScrollUpVisible(window.pageYOffset > 404 ? true : false);
            scrollUpVisible = window.pageYOffset > navHeight ? true : false;
            prevScrollY.current = currentScrollY;
            // update the DOM
            var scrollUpDownClass = (initialNav ? (goingUp ? (scrollUpVisible ? "scroll-up" : "") : (wasScrolledUp.current ? "scroll-down" : "")) : '');
            var navFixedClass = (navTop ? "nav-fixed" : "");
            clearTimeout(hideNavTimeout.current);
            if (!!scrollUpDownClass && !!forceHide) {
                scrollUpDownClass = "scroll-down";
            }
            else if (scrollUpDownClass == "scroll-up") {
                var isMobile = window.innerWidth < 768;
                if (!isMobile) {
                    hideNavTimeout.current = setTimeout(function () {
                        tryHideNav(function () { handleNavVisibility(true); });
                    }, 2000);
                }
            }
            if (navElement.current) {
                navElement.current.classList.remove("scroll-up");
                navElement.current.classList.remove("scroll-down");
                navElement.current.classList.remove("nav-fixed");
                if (scrollUpDownClass) {
                    navElement.current.classList.add(scrollUpDownClass);
                }
                if (navFixedClass) {
                    navElement.current.classList.add(navFixedClass);
                }
            }
            if (navPlaceholderElement.current) {
                navPlaceholderElement.current.style.display = !!scrollUpDownClass ? "block" : "none";
            }
            var currentNavHeight = (navElement.current && navElement.current.getBoundingClientRect().height || 0);
            if ((!!navFixedClass || !(scrollUpDownClass)) && !areNumbersEqualWithMargin(currentNavHeight, navHeight, 10)) {
                handleResize();
            }
        };
        var handleScroll = function () {
            handleNavVisibility();
        };
        // Add click event listener to the document
        // Function to handle click event
        function handleDocumentClick(event) {
            var targetElement = navElement.current;
            if (!targetElement)
                return;
            // Check if the target of the click event is not the target element or its descendants
            if (targetElement != event.target && !targetElement.contains(event.target)) {
                clearTimeout(hideNavTimeout.current);
                handleNavVisibility(true);
            }
        }
        document.addEventListener('click', handleDocumentClick);
        window.addEventListener("scroll", handleScroll, { passive: true });
        window.addEventListener("resize", handleResize);
        return function () {
            document.addEventListener('click', handleDocumentClick);
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    useEffect(function () {
        if (closeMobileNav) {
            document.body.classList.add('overflow-hidden');
        }
        else {
            document.body.classList.remove('overflow-hidden');
        }
    }, [closeMobileNav]);
    //const { menuData, generalSettings } = props;
    var isHomePage = function () {
        if ((window.location.pathname || "").toLowerCase() == (rootUrl || '/').toLowerCase()) {
            return true;
        }
        return false;
    };
    function setVisibilityNavItems() {
        if (closeMobileNav) {
            setNavMobileHeight(0);
        }
        setCloseMobileNav(!closeMobileNav);
    }
    var mouseEnterNav = function (i) {
        setHoverNavIndex(i);
    };
    var mouseLeaveNav = function (i) {
        setHoverNavIndex(null);
    };
    var clickNav = function (e, i) {
        if (e.key === 'Enter' || e.charCode === 13) {
            if (clickNavIndex == i) {
                setClickNavIndex(null);
            }
            else {
                setClickNavIndex(i);
            }
        }
    };
    var handleDivBlur = function (i) {
        if (clickNavIndex != i) {
            setClickNavIndex(null);
        }
    };
    //const mobileIndexNav = (i: any) => {
    //    if (mobileNavIndex == i) {
    //        setMobileNavIndex(null);
    //    }
    //    else {
    //        setMobileNavIndex(i);
    //    }
    //}
    var handleNavMouseOver = function () {
        isNavHovered.current = true;
    };
    var handleNavMouseOut = function () {
        isNavHovered.current = false;
    };
    var navBarItems = function (item, i) {
        return (React.createElement(React.Fragment, { key: i },
            React.createElement("li", { className: "nav-item" + (item.children ? " has-children" + (hoverNavIndex == i ? " minus" : " plus") : ""), onMouseEnter: function () { return mouseEnterNav(i); }, onMouseLeave: function () { return mouseLeaveNav(i); }, onBlur: function () { return handleDivBlur(i); } },
                item.fields.title && (item.fields.link || item.fields.link.length == 0) &&
                    React.createElement(React.Fragment, null,
                        checkUrlIsExternal(item.fields.link) && item.fields.link.length > 0 &&
                            React.createElement("a", { href: (item.fields.link && item.fields.link.length > 0) ? item.fields.link : "#", onClick: function (e) {
                                    if (!(item.fields.link || "").length) {
                                        e.preventDefault();
                                    }
                                }, target: item.fields.openinNewWindow ? "_blank" : "_self", rel: item.fields.openinNewWindow ? "noopener noreferrer" : "", title: item.fields.title, tabIndex: 0 }, item.fields.title),
                        !checkUrlIsExternal(item.fields.link) && item.fields.link.length == 0 && item.children &&
                            React.createElement("span", null, item.fields.title),
                        !checkUrlIsExternal(item.fields.link) && item.fields.link.length > 0 &&
                            React.createElement(Link, { to: item.fields.link, target: item.fields.openinNewWindow ? "_blank" : "_self", rel: item.fields.openinNewWindow ? "noopener noreferrer" : "", title: item.fields.title, tabIndex: 0 }, item.fields.title),
                        item.children &&
                            React.createElement("button", { type: "submit", value: "Submit", "aria-label": "Close", className: "btn btn-more-icon border-0 bg-transparent " + (clickNavIndex == i ? "minus" : ""), onKeyDown: function (e) { return clickNav(e, i); } })),
                item.children &&
                    React.createElement("ul", { className: "children-items " + ((hoverNavIndex == i || clickNavIndex == i) ? "active" : "") }, item.children.map(function (child, j) {
                        return (React.createElement("li", { className: "child" },
                            React.createElement("i", { className: "fa-solid fa-arrow-right" }),
                            React.createElement(Link, { to: child.fields.link, target: child.fields.openinNewWindow ? "_blank" : "_self", rel: child.fields.openinNewWindow ? "noopener noreferrer" : "", title: child.fields.title, onClick: function () { return setClickNavIndex(null); } }, child.fields.title)));
                    })))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("nav", { ref: navElement, id: "navbar", onMouseOver: handleNavMouseOver, onMouseOut: handleNavMouseOut, className: "bg-black navbar py-3 nav-fixed" },
            React.createElement("div", { className: "container-fluid d-block position-relative", itemScope: true, itemType: "https://schema.org/Organization" },
                React.createElement("div", { className: "row", id: "phone-hours" },
                    React.createElement("div", { className: "col" },
                        React.createElement("div", { className: "d-flex justify-content-between align-items-center navbar-top" },
                            generalSettings && React.createElement("div", { className: " phone-and-hours fs-sm d-flex justify-content-end" },
                                generalSettings.fields.phoneNumber && React.createElement("div", { className: "phone-number me-4" },
                                    React.createElement("a", { href: "tel:" + generalSettings.fields.phoneNumber, title: "Call Us", className: "d-flex align-items-center flex-nowrap " },
                                        React.createElement("div", { className: "" },
                                            React.createElement("i", { className: "fa-solid fa-phone" })),
                                        React.createElement("div", { className: "d-flex align-items-center flex-wrap" },
                                            React.createElement("span", { className: "call-text me-2" }, "CALL"),
                                            React.createElement("span", { className: "number" }, generalSettings.fields.phoneNumber)))) || null,
                                (generalSettings.fields.openClosedLabel || generalSettings.fields.openingHours) && React.createElement("div", { className: "open-hours" },
                                    React.createElement(Link, { to: generalSettings.fields.openingHoursUrl, title: "View Opening Hours", className: "d-flex align-items-center flex-nowrap " },
                                        React.createElement("div", null,
                                            React.createElement("i", { className: "fa-regular fa-clock" })),
                                        React.createElement("div", { className: "d-flex align-items-center flex-wrap" },
                                            generalSettings.fields.openClosedLabel && React.createElement("span", { className: "open-text me-2" }, generalSettings.fields.openClosedLabel) || null,
                                            generalSettings.fields.openingHours && React.createElement("span", { className: "open-hours" }, generalSettings.fields.openingHours) || ""))) || null) || null,
                            React.createElement("div", { className: "links d-none d-lg-flex justify-content-end p-0" },
                                React.createElement("ul", { className: "primary-nav list-unstyled d-flex align-items-center m-0" }, menuData && menuData.children.map(function (item, i) {
                                    return (navBarItems(item, i));
                                })))))),
                React.createElement("div", { className: "row flex-wrap" },
                    React.createElement("div", { className: "col-lg-7 col-xl-4 header-logo d-flex justify-content-between mb-4 mb-lg-0", id: "logo-mobile" },
                        React.createElement("meta", { itemProp: "name", content: "FlyOver" }),
                        React.createElement(Link, { to: rootUrl || "/", className: "navbar-brand", id: "homePageLink", title: "Flyover Logo", "aria-label": "FlyOver Logo" }, generalSettings.fields.logo &&
                            React.createElement("img", { src: generalSettings.fields.logo, alt: generalSettings.fields.logo_description ? generalSettings.fields.logo_description : "FlyOver Logo", height: "42", className: "header-logo img-fluid", itemProp: "logo" })),
                        React.createElement("button", { type: "submit", value: "Submit", id: "btnNavToggle", className: "navbar-toggler ms-4 my-auto btn-navbar btn-mh btn btn-secondary d-block d-lg-none" + (closeMobileNav ? " close" : ""), "aria-label": "Navbar Toggle", onClick: setVisibilityNavItems },
                            React.createElement("span", { className: "menu-bar" }),
                            React.createElement("span", { className: "menu-bar" }),
                            React.createElement("span", { className: "menu-bar" }))),
                    React.createElement("div", { className: "col-lg-12 d-lg-none position-relative" },
                        React.createElement(Collapse, { isOpen: closeMobileNav, className: "mobile-nav-items", style: { height: navMobileHeight, overflow: 'auto' } },
                            React.createElement("ul", { className: "menu-items" }, menuData && menuData.children.map(function (item, i) {
                                return (React.createElement(MobileNavBarItems, { item: item, i: i, setCloseMobileNav: setCloseMobileNav, mobileNavIndex: mobileNavIndex, setMobileNavIndex: setMobileNavIndex }));
                            })))),
                    !isHomePage() && !hideBookNow && generalSettings && generalSettings.fields.bookingBtnLabel && generalSettings.fields.bookingBtnUrl &&
                        React.createElement("div", { className: "col-lg-5 col-xl-8 header-button d-none d-lg-flex align-items-center justify-content-end" }, React.createElement(Link, { type: "button", className: "btn btn-primary btn-mh ms-4", title: generalSettings.fields.bookingBtnLabel ? generalSettings.fields.bookingBtnLabel : "Buy Tickets & Passes", to: generalSettings.fields.bookingBtnUrl ? generalSettings.fields.bookingBtnUrl : "#", target: generalSettings.fields.bookingBtnOpenNewTab ? "_blank" : "_self", rel: generalSettings.fields.bookingBtnOpenNewTab ? "noopener noreferrer" : "" }, generalSettings.fields.bookingBtnLabel) || null),
                    isHomePage() &&
                        React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "col-lg-7 col-xl-5 header-title mt-4 pt-5 pt-lg-0 mt-lg-0" }, menuData.fields.navbarAnnoucementTitle &&
                                React.createElement(TitleTag, { className: "title-navbar text-uppercase " + (menuData.fields.titleStyle ? menuData.fields.titleStyle : ""), dangerouslySetInnerHTML: { __html: menuData.fields.navbarAnnoucementTitle } })),
                            React.createElement("div", { className: "col-lg-5 pt-0 mt-4 mt-xl-0 pt-lg-5 pt-xl-0 col-xl-3 header-content" }, menuData.fields.navbarAnnoucementSubtitle &&
                                React.createElement(SubtitleTag, { className: "subtitle-navbar " + (menuData.fields.subtitleStyle ? menuData.fields.subtitleStyle : ""), dangerouslySetInnerHTML: { __html: menuData.fields.navbarAnnoucementSubtitle } })))),
                isHomePage() && !hideBookNow && generalSettings.fields.bookingBtnLabel && generalSettings.fields.bookingBtnLabel.length > 0 && generalSettings.fields.bookingBtnUrl && generalSettings.fields.bookingBtnUrl.length > 0 &&
                    React.createElement("div", { className: "row gx-0 d-none d-lg-flex btn-reserve mb-4 w-100" },
                        React.createElement("div", { className: "col d-flex" }, React.createElement("a", { type: "button", className: "btn btn-primary btn-book ms-auto", title: generalSettings.fields.bookingBtnLabel ? generalSettings.fields.bookingBtnLabel : "Buy Tickets & Passes", href: generalSettings.fields.bookingBtnUrl ? generalSettings.fields.bookingBtnUrl : "#", target: generalSettings.fields.bookingBtnOpenNewTab ? "_blank" : "_self", rel: generalSettings.fields.bookingBtnOpenNewTab ? "noopener noreferrer" : "" }, generalSettings.fields.bookingBtnLabel) || null)))),
        React.createElement("div", { ref: navPlaceholderElement, className: "nav-placeholder", style: { display: "none" } }, "\u00A0")));
}
